import { createRemoteComponent } from '@remote-ui/core';

/**
 * Grid is used to lay out content in a matrix of rows and columns.
 */
const Grid = createRemoteComponent('Grid');

export { Grid };
